import AppError from 'errors/app-error'

export default class ToolLibrariesEmptyError extends AppError {
  constructor() {
    super()
    this.statusCode = 412
    this.message =
      'At least one tool library must exist to complete this action.'
  }
}
